<template>
	<div class="realname">
		<infoHeader :title="title"></infoHeader>
		<div class="fixation">
			<div class="register-form">
				<el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="120px">
					<div class="welcome">
						实名认证
					</div>
					<el-form-item label="姓名" prop="realname">
						<el-input type="text" v-model="ruleForm.realname" placeholder="请输入姓名"></el-input>
					</el-form-item>
					<el-form-item label="身份证号" prop="identity">
						<el-input type="text" v-model="ruleForm.identity" placeholder="请输入身份证号"></el-input>
					</el-form-item>
					<el-form-item>
						<div class="dialog-button">
							<el-button type="danger" plain @click="resetForm('ruleForm')">重置</el-button>
							<el-button type="danger" :loading="loading" @click="submitForm('ruleForm')">提交</el-button>
						</div>
					</el-form-item>
					<el-form-item>
						<div class="dialog-agreement">
							<el-checkbox v-model="checked"></el-checkbox>阅读并接受<router-link :to="{
								path:'/agreement',
								query:{
									id:'1961d643e0dc4c83b98b005eb7e8303b'
								}
							}">用户协议</router-link>及
							<router-link :to="{
								path:'/agreement',
								query:{
									id:'72beccc591c349528934ff34b832befb'
								}
							}">隐私政策</router-link>
						</div>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<el-dialog :visible="successDialog" :show-close="false" top="280px" width="600px">
			<div class="login-dialog-title">
				<i class="el-icon-circle-check"></i>实名认证成功
			</div>
			<div class="button">
				<el-button @click="closeSuccess, goIndex()" plain type="danger" round v-if="type==1">返回首页</el-button>
				<el-button @click="closeSuccess, goSetting()" plain type="danger" round v-else>返回个人中心</el-button>
			</div>
		</el-dialog>
		<pubfooter></pubfooter>
	</div>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	export default {
		name: 'realname',
		data() {
			let verify_identity = (rule, value, callback) => {
				if (!this.$ver.verify_identity(this.ruleForm.identity)) {
					callback(new Error('请输入正确的身份证号。'))
				} else {
					callback()
				}
			}
			return {
				title: '实名认证',
				ruleForm: {
					realname: '',
					identity: ''
				},
				rule: {
					realname: [{
						required: true,
						trigger: 'blur',
						message: '请输入真实姓名。'
					}],
					identity: [{
						required: true,
						trigger: 'blur',
						validator: verify_identity
					}],
				},
				checked: false,
				successDialog: false,
				loading: false,
				type: 1
			};
		},
		methods: {
			...mapMutations(['saveUserinfo']),
			resetForm(formName) {
				this.$refs[formName].resetFields()
			},
			submitForm(formName) {
				if (!this.checked) {
					this.$message({
						message: '请阅读《用户协议》与《隐私政策》后再继续。',
						type: 'error',
						duration: 2000
					})
					return
				}
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.loading = true
						this.$api.frontReal({
							realName: this.ruleForm.realname,
							idCard: this.ruleForm.identity,
							userId: this.$store.state.userinfo.userId
						}, res => {
							this.loading = false
							if (res.code == 200) {
								let userinfo = this.$store.state.userinfo
								userinfo.authentication = 1
								this.saveUserinfo(userinfo)
								this.successDialog = true
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			closeSuccess() {
				this.successDialog = false
			},
			goIndex() {
				this.$router.push({
					path: '/'
				})
			},
			goSetting() {
				this.$router.push({
					path: '/setting'
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.type = this.$route.query.type
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.fixation {
		display: flex;
		justify-content: center;
		padding: @vue-spacing-col-lg*2 0px;
	}

	.login-dialog-title {
		width: 100%;
		height: 80px;
		display: flex;
		justify-content: center;
		font-size: @vue-font-size-lg;
		color: @vue-text-color-red;

		i {
			margin-top: @vue-spacing-col-sm;
			margin-right: @vue-spacing-row-sm;
		}
	}

	.button {
		width: 100%;
		display: flex;
		justify-content: center;
		margin-top: @vue-spacing-col-lg;
	}
</style>
